/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Delete_BusyInputs */

const en_us2_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting…`)
};

const pt_br2_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagando…`)
};

const es_419_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando…`)
};

const pt_pt2_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A apagar…`)
};

const fr_fr2_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression…`)
};

const de_de2_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gelöscht…`)
};

const it_it2_coach_manage_delete_busy = /** @type {(inputs: Coach_Manage_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminazione…`)
};

/**
* | output |
* | --- |
* | "Deleting…" |
*
* @param {Coach_Manage_Delete_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_delete_busy = /** @type {((inputs?: Coach_Manage_Delete_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Delete_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_delete_busy(inputs)
	if (locale === "es-419") return es_419_coach_manage_delete_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_delete_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_delete_busy(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_delete_busy(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_delete_busy(inputs)
	return en_us2_coach_manage_delete_busy(inputs)
});
export { coach_manage_delete_busy as "coach-manage.delete_busy" }